import React from 'react';
import {withRouter} from "react-router-dom";

import LoadingImage from "../../atoms/loading-image";

import './index.scss';
import Message from "../message";
import {data} from "../../../util/data";

class Lookbook extends React.Component {

  static defaultProps = {
    photos: null
  };

  render() {

    if (! this.props.photos) {
      return null;
    }

    if (! this.props.photos.length) {
      return (
        <Message text={data.noLookbookPhotos} mode="note" />
      );
    }

    let photos = this.props.photos.map(photo => {

      let renderedPhoto = (
        <div className="lookbook__img">
          <LoadingImage src={photo.photo.extraLarge} />
        </div>
      );

      let annotationProducts;

      if (photo.products.length) {
        annotationProducts = photo.products.map(product => {
          return (
            <button key={product.id} className='lookbook__annotation-link' onClick={e => this.props.history.push('/shop/'+product.path)}>{product.name}</button>
          );
        });
      }

      return (
        <div className="lookbook__photo" key={photo.id}>
          {renderedPhoto}
          {annotationProducts &&
            <div className="lookbook__annotation">
              {annotationProducts}
            </div>
          }
        </div>
      );

    });

    return (
      <div className="lookbook">
        {photos}
      </div>
    );
  }
}

export default withRouter(Lookbook);